document.addEventListener('DOMContentLoaded', function () {
    const counters = document.querySelectorAll('.sds-number-counter, .dpp-number-counter, .ldc-number-counter, .lsc-number-counter');
    const banners = document.querySelectorAll('.sds-banner, .dpp-banner, .ldc-banner, .lsc-banner');

    function animateCounter(valueEl, target, prefix, duration) {
        const start = 0;
        const startTime = performance.now();

        function update(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            const eased = 1 - Math.pow(1 - progress, 3);
            const current = Math.floor(eased * (target - start) + start);

            valueEl.textContent = prefix + current;

            if (progress < 1) {
                requestAnimationFrame(update);
            } else {
                valueEl.textContent = prefix + target;
            }
        }

        requestAnimationFrame(update);
    }

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                const el = entry.target;

                if (el.classList.contains('sds-number-counter') || el.classList.contains('dpp-number-counter') || el.classList.contains('ldc-number-counter') || el.classList.contains('lsc-number-counter')) {
                    const valueEl = el.querySelector('[class$="__value"]');
                    const target = parseInt(el.getAttribute('data-target'), 10);
                    const speed = parseInt(el.getAttribute('data-speed'), 10) || 2000;
                    const prefix = el.getAttribute('data-prefix') || '';
                    animateCounter(valueEl, target, prefix, speed);
                }

                if (el.classList.contains('sds-banner') || el.classList.contains('dpp-banner') || el.classList.contains('ldc-banner') || el.classList.contains('lsc-banner')) {
                    el.classList.add('is-visible');
                }

                observer.unobserve(el);
            }
        });
    }, {
        threshold: 0.2,
    });

    counters.forEach(function (counter) {
        observer.observe(counter);
    });

    banners.forEach(function (banner) {
        observer.observe(banner);
    });
});
